import { render, staticRenderFns } from "./JunkIcon.vue?vue&type=template&id=342e4da8&functional=true"
import script from "./JunkIcon.vue?vue&type=script&lang=js"
export * from "./JunkIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports